import { ExtendedCreateUserInput } from '@/types/schema';

import { CollaboratorFormShape } from './CollaboratorModal.constants';

function getHouseholdIDs(
  formValues: CollaboratorFormShape,
  canViewHouseholds: boolean
): string[] {
  if (!canViewHouseholds) {
    return [];
  }

  return formValues.associatedClientIds;
}

export function mapFormDataToInput(
  formValues: CollaboratorFormShape,
  canViewHouseholds: boolean = true
): ExtendedCreateUserInput {
  // this all uses the "create" paradigm, but internally to the endpoint
  // we will skip user creation if an email of an existing user already matches
  const householdIDs = getHouseholdIDs(formValues, canViewHouseholds);
  return {
    create: {
      email: formValues.email,
      firstName: formValues.firstName,
      lastName: formValues.lastName,
    },
    withCollaborator: {
      firstName: formValues.firstName,
      lastName: formValues.lastName,
      kind: formValues.role || null,
      title: formValues.title || null,
      organizationName: formValues.organization || null,
      householdIDs: householdIDs,
      roleID: formValues.roleId || null,
    },
  };
}
